import type { TargettedEvent } from '@suntex.core/animation';
import {
  Calculator,
  Chance,
  LoadUtil,
  TestUtil,
  Timer,
  UIUtil,
} from '@suntex.core/animation';
import { ValueText, createGameFrame } from '@suntex.modules/core';

import {
  REDO_GAME_ARRAY_FLAG3,
  REDO_LEFT_ARRAY,
  REDO_RIGHT_ARRAY,
  REDO_START_SECONDS_DEFAULT,
  REDO_START_SECONDS_FLAG1,
} from './data/vifRedoAddSubData';
import { VIF_BOARD_SOUND_FILES } from './data/vifSounds';
import type {
  RedoAddSubGameStage,
  VifEndScreenSymbol,
  VifGameProgArgs,
  VifNumberButtonHitArea,
  VifNumberPanel,
  VifNumberPanelButton,
  VifNumberPanelMarker,
  VifSpinner,
  VifSpinnerDigitHitArea,
} from './types';

const ADD = 1,
  SUB = 2;

export function VIFRedoAddSub_prog({
  api,
  exportRoot,
  params,
  onComplete,
}: VifGameProgArgs) {
  let startSeconds: number[] = [0, 0, 0, 0];
  let clockSeconds = 0;
  const clockTimer = new Timer(1000, onTick);
  let clockPaused = false;
  // Game Data
  let gameFlag = 1; //0 = redo v1, 1 = undo, 2 = undo v2, 3 = undo v3 (11-18), 4 = undo v3 (21-99), 5 = undo v4 (21-98)
  let vifStage = 1;
  let playerId = 0;

  let blnCorrectAnswer = false;
  let blnRandom = true;
  let blnUsedAnswer = false;
  let intBlinks = 0;
  const leftArray: number[][] = REDO_LEFT_ARRAY;
  const rightArray: number[][] = REDO_RIGHT_ARRAY;
  let gameArray: number[] = [0, 0];
  let gameArrayChosen: (number | boolean)[] = [0, 0];
  let intAnswer = 0;
  let arrSelected: boolean[][] = [
    [false],
    [false],
    [false, false],
    [false, false],
    [false, false, false],
    [false, false, false],
    [false, false, false, false],
    [false, false, false, false],
    [false, false, false, false, false],
  ];
  let index1 = 0;
  let index2 = 0;
  let seqindex1 = 0;
  let seqindex2 = 0;
  let intAnswered = 0;
  let slideFrame = 0;
  let blinkLimit = 4;

  // Visuals
  let submitButton: createjs.MovieClip;
  let buttonsClickable = true;
  let leftSpinner: VifSpinner;
  let leftSpinnerAlt: VifSpinner;
  let rightSpinner: VifSpinner;
  let rightSpinnerAlt: VifSpinner;
  let correction: ValueText;
  let numberPanel: VifNumberPanel;
  let buttonArray: VifNumberPanelButton[];
  let markerArray: VifNumberPanelMarker[][];
  let opBtn: createjs.MovieClip & { submitButton: createjs.MovieClip };
  const leftSpinnerPrefix = 'leftSpinner.';
  const rightSpinnerPrefix = 'rightSpinner.';

  const gameFrame = createGameFrame({
    api,
    exportRoot,
    params: {
      playerId: params.playerId,
      moduleId: params.moduleId,
      moduleVariant: params.moduleVariant,
      preview: params.preview,
      soundDirectory: params.soundDirectory,
      hubUrl: params.hubUrl,
    },
  });
  const gameStage = exportRoot.gameStage as RedoAddSubGameStage;
  gameFrame.init();

  VIFRedoAddSub();

  function VIFRedoAddSub() {
    gameFrame.moduleVariant = params.moduleVariant;
    playerId = params.playerId;
    vifStage = params.stage;

    if (gameFrame.moduleId == 174) {
      if (gameFrame.moduleVariant == 1) {
        gameFlag = 4;
      } else if (gameFrame.moduleVariant == 0) {
        gameFlag = 1;
      } else {
        gameFlag = 1;
        gameFrame.moduleVariant = 0;
      }
    } else if (gameFrame.moduleId == 175) {
      gameFlag = gameFrame.moduleVariant + 3;
    }

    gameFrame.gamesPerRound = 1;
    gameFrame.roundsInModule = 4;

    gameFrame.disableMoreBtn = true;
    gameFrame.disableNextBtn = true;

    gameFrame.scoreboard.updateGame(null);

    //UIUtil.setFrame(gameStage.opBtn1, gameFlag);
    //gameFlag = 4;

    leftSpinner = gameStage.lSpinner;
    if (gameFlag == 2 || gameFlag == 3 || gameFlag == 4 || gameFlag == 5) {
      leftSpinner = gameStage.lSpinnerAlt;
      leftSpinnerAlt = gameStage.lSpinner;
    } else {
      leftSpinner = gameStage.lSpinner;
      leftSpinnerAlt = gameStage.lSpinnerAlt;
    }
    if (gameFlag == 5) {
      rightSpinner = gameStage.rSpinnerAlt;
      rightSpinnerAlt = gameStage.rSpinner;
    } else {
      rightSpinner = gameStage.rSpinner;
      rightSpinnerAlt = gameStage.rSpinnerAlt;
    }

    blinkLimit = gameFlag >= 2 ? 1 : 4;

    UIUtil.moveTo(leftSpinnerAlt, -400, -400, 0, undefined);
    UIUtil.moveTo(rightSpinnerAlt, -400, -400, 0, undefined);
    numberPanel = gameStage.numberPnl;
    correction = gameStage.stopLight.v;
    opBtn = gameStage.stopLight.opBtn;
    submitButton = opBtn.submitButton;
    buttonArray = [
      numberPanel.b2,
      numberPanel.b3,
      numberPanel.b4,
      numberPanel.b5,
      numberPanel.b6,
      numberPanel.b7,
      numberPanel.b8,
      numberPanel.b9,
      numberPanel.bA,
    ];
    for (let i = 0; i < buttonArray.length; i++) {
      UIUtil.fadeTo(buttonArray[i]!.ha, 0.01);
    }
    markerArray = [
      [numberPanel.n2a],
      [numberPanel.n3a],
      [numberPanel.n4a, numberPanel.n4b],
      [numberPanel.n5a, numberPanel.n5b],
      [numberPanel.n6a, numberPanel.n6b, numberPanel.n6c],
      [numberPanel.n7a, numberPanel.n7b, numberPanel.n7c],
      [numberPanel.n8a, numberPanel.n8b, numberPanel.n8c, numberPanel.n8d],
      [numberPanel.n9a, numberPanel.n9b, numberPanel.n9c, numberPanel.n9d],
      [
        numberPanel.nAa,
        numberPanel.nAb,
        numberPanel.nAc,
        numberPanel.nAd,
        numberPanel.nAe,
      ],
    ];
    initInterface();
    gameFrame.initGame(startGame, stopGame);

    startSeconds.length = 0;
    startSeconds = [...REDO_START_SECONDS_DEFAULT];
  }

  function continueVIF() {
    let operation;
    if (gameFrame.moduleId == 175) {
      operation = SUB;
    } else {
      operation = ADD;
    }

    if (typeof onComplete === 'function') {
      onComplete(playerId, operation, vifStage);
    } else {
      TestUtil.log('videoComplete function not found on window');
    }
  }

  function stopGame() {
    enableCalculatorButtons(false);
    enableSubmitButton(false);

    const continueBtn = (gameFrame.endScreen as VifEndScreenSymbol).continueBtn;

    if (gameFrame.preview) {
      UIUtil.hide(gameFrame.practiceMenu.moreBtn);
      UIUtil.hide(gameFrame.endScreen.moreBtn);
      UIUtil.hide(gameFrame.endScreen.nextBtn);
      UIUtil.hide(continueBtn);
      //UIUtil.createButton(gameFrame.practiceMenu.continueBtn, continueVIF, 0, onButtonOver, onButtonOut);
      //UIUtil.createButton(gameFrame.endScreen.continueBtn, continueVIF, 0, onButtonOver, onButtonOut);
      //UIUtil.hide(gameFrame.practiceMenu.continueBtn.btnHover);
    } else if (
      gameFrame.round == gameFrame.roundsInModule &&
      gameFrame.game == gameFrame.gamesPerRound
    ) {
      gameFrame.disableNextBtn = true;
      gameFrame.disableMoreBtn = true;
      UIUtil.show(continueBtn);
      UIUtil.createButton<{
        value?: unknown;
        btnHover: createjs.DisplayObject;
      }>(continueBtn, continueVIF, 0, onButtonOver, onButtonOut);
      UIUtil.hide(continueBtn.btnHover);
    } else {
      gameFrame.disableNextBtn = false;
      UIUtil.hide(continueBtn);
    }

    UIUtil.hide(gameStage, 500);
    resetStartButton();
  }

  function startGame() {
    loadSounds();
    UIUtil.show(gameStage, 500);
    UIUtil.setFrame(numberPanel, 1);
    gameFrame.scoreboard.hideMeter();
    gameFrame.scoreboard.updateRound(gameFrame.round);
    gameFrame.scoreboard.updateGame(null);
    setupGame();
    resetGame();
  }

  function setupGame() {
    //These may vary by gameFlag
    //intRound = gameFrame.round;

    switch (gameFlag) {
      case 1:
        if (gameFrame.round == 1 || gameFrame.round == 3) {
          blnRandom = false;
        } else {
          blnRandom = true;
        }
        startSeconds.length = 0;
        startSeconds = [...REDO_START_SECONDS_FLAG1];
        break;
      case 3:
        gameArray.length = 0;
        gameArray = [...REDO_GAME_ARRAY_FLAG3];
        gameArrayChosen.length = 0;
        gameArrayChosen = [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ];
        break;
      default:
        break;
    }

    if (gameFlag == 1) {
      intAnswered = 1;
    }

    if (gameFlag == 3) {
      UIUtil.setFrame(leftSpinner, 3);
      UIUtil.delay(waitLeftSpinnerSetup, 50);
    }

    if (gameFlag == 0) {
      UIUtil.setFrame(leftSpinner, 2);
      UIUtil.setFrame(rightSpinner, 2);
      UIUtil.fadeTo(leftSpinner.sel.ha, 0.01);
      UIUtil.fadeTo(rightSpinner.sel.ha, 0.01);
    }
  }

  function waitLeftSpinnerSetup() {
    UIUtil.setFrame(leftSpinner.sel.n, 10);
    UIUtil.hide(leftSpinner.sel.ha);
  }
  /* Sounds */

  function loadSounds() {
    gameFrame.loadSound('click3.mp3', 'click');
    for (const [id, file] of Object.entries(VIF_BOARD_SOUND_FILES)) {
      gameFrame.loadSound(file, id);
    }
  }

  /* Interface */

  function initInterface() {
    initButtons();
    enableNumberButtons(false);

    for (let k = 0; k < markerArray.length; k++) {
      for (let l = 0; l < markerArray[k]!.length; l++) {
        ValueText.init(markerArray[k]![l]!.txtExpression);
      }
    }
  }

  function initButtons() {
    UIUtil.createButton(
      gameStage.startButton,
      activateStartButton,
      false,
      undefined,
      undefined,
    );
    if (gameFlag >= 1) {
      UIUtil.createButton(
        submitButton,
        submitClicked,
        null,
        buttonMouseOver,
        buttonMouseOut,
      );
      enableSubmitButton(false);
    } else {
      for (let i = 0; i < buttonArray.length; i++) {
        //UIUtil.createButton(buttonArray[i], numberClicked, false, buttonMouseOver, buttonMouseOut);
        if (i == 8) {
          UIUtil.createButton(buttonArray[i]!.ha, vClicked, 'bA');
        } else {
          UIUtil.createButton(
            buttonArray[i]!.ha,
            vClicked,
            'b' + (i + 2).toString(),
          );
        }
      }
      //UIUtil.hide(submitButton,0,null);
    }

    if (gameFlag >= 2) {
      for (let j = 0; j < buttonArray.length; j++) {
        UIUtil.hide(buttonArray[j], 0);
      }
      for (let k = 0; k < markerArray.length; k++) {
        for (let l = 0; l < markerArray[k]!.length; l++) {
          UIUtil.hide(markerArray[k]![l]);
        }
      }
    }
  }

  function onButtonOver(
    e: TargettedEvent<{ btnHover: createjs.DisplayObject }>,
  ) {
    const btn = UIUtil.getEventTarget(e);
    UIUtil.show(btn.btnHover, 100);
  }

  function onButtonOut(
    e: TargettedEvent<{ btnHover: createjs.DisplayObject }>,
  ) {
    const btn = UIUtil.getEventTarget(e);
    UIUtil.hide(btn.btnHover, 100);
  }

  function vClicked(e: TargettedEvent<{ value: string }>) {
    const btn = UIUtil.getEventTarget<{ value: string }>(e);

    enableSubmitButton(false);

    const nm = btn.value.substring(2, 1);
    let val: number | string = 1;
    if (nm == 'A') {
      val = 10;
    } else {
      val = nm;
    }
    if (val == intAnswer) {
      correctAnswer();
    } else {
      incorrectAnswer();
    }
    enableNumberButtons(false);
  }

  function waitNumberClick(
    e: TargettedEvent<{ value: string; parent: VifSpinner }>,
  ) {
    //createjs.Ticker.removeEventListener("tick", waitNumberClick);
    const btn = UIUtil.getEventTarget(e);
    let p: VifSpinner = btn.parent;
    let i: number | undefined;
    if (btn.value.substr(0, 4) == 'left') {
      i = Calculator.getInt(btn.value.substr(13, 1));
      p = leftSpinner;
    } else if (btn.value.substr(0, 5) == 'right') {
      i = Calculator.getInt(btn.value.substr(14, 1));
      p = rightSpinner;
    }

    UIUtil.createButton(
      p.sel.ha,
      undoClicked,
      btn.value,
      buttonMouseOverp,
      buttonMouseOutp,
    );

    if (
      (gameFlag == 2 || gameFlag == 4 || gameFlag == 5) &&
      btn.value.substr(0, 1) == 'l'
    ) {
      UIUtil.setFrame(p.sel.n, i! + 9);
    } else if (gameFlag == 5 && btn.value.substr(0, 1) == 'r') {
      UIUtil.setFrame(p.sel.n, i! + 18);
    } else {
      UIUtil.setFrame(p.sel.n, i!);
      UIUtil.fadeTo(p.sel.ha, 0.01);
    }

    if (
      UIUtil.getCurrentFrame(leftSpinner) == 2 &&
      UIUtil.getCurrentFrame(rightSpinner) == 2
    ) {
      enableSubmitButton(true);
    } else {
      enableSubmitButton(false);
    }
  }

  function numberClicked(e: TargettedEvent<VifSpinnerDigitHitArea>) {
    //TestUtil.log("numberClicked");
    if (buttonsClickable) {
      const btn = UIUtil.getEventTarget(e).parent;
      const p = btn.parent;

      UIUtil.setFrame(p, 2);
      UIUtil.fadeTo(p.sel.ha, 0.01);
      //createjs.Ticker.addEventListener("tick", waitNumberClick);
      UIUtil.delay(waitNumberClick, 40, [e]);
    }
  }

  function undoClicked(e: TargettedEvent<VifNumberButtonHitArea>) {
    if (buttonsClickable) {
      const n = UIUtil.getEventTarget(e);
      const v = n.value;
      UIUtil.setFrame(n, 1);
      const par = n.parent;
      UIUtil.setFrame(par, 1);
      enableSubmitButton(false);
      if (v.substr(0, 1) == 'l') {
        UIUtil.hide(leftSpinner);
        UIUtil.setFrame(leftSpinner, 1);
        enableMyButtons(leftSpinner, true);
      } else {
        UIUtil.hide(rightSpinner);
        UIUtil.setFrame(rightSpinner, 1);
        enableMyButtons(rightSpinner, true);
      }
    }
  }

  function createCalcButtons(mc: VifSpinner, prefix: string) {
    if (!(gameFlag == 3 && prefix.substr(0, 1) == 'l') && gameFlag != 0) {
      UIUtil.setFrame(mc, 1);
      UIUtil.fadeTo(mc.s1.ha, 0.01);
      UIUtil.fadeTo(mc.s2.ha, 0.01);
      UIUtil.fadeTo(mc.s3.ha, 0.01);
      UIUtil.fadeTo(mc.s4.ha, 0.01);
      UIUtil.fadeTo(mc.s5.ha, 0.01);
      UIUtil.fadeTo(mc.s6.ha, 0.01);
      UIUtil.fadeTo(mc.s7.ha, 0.01);
      UIUtil.fadeTo(mc.s8.ha, 0.01);
      UIUtil.fadeTo(mc.s9.ha, 0.01);
      UIUtil.createButton(
        mc.s1.ha,
        numberClicked,
        prefix + 's1',
        buttonMouseOverp,
        buttonMouseOutp,
      );
      UIUtil.createButton(
        mc.s2.ha,
        numberClicked,
        prefix + 's2',
        buttonMouseOverp,
        buttonMouseOutp,
      );
      UIUtil.createButton(
        mc.s3.ha,
        numberClicked,
        prefix + 's3',
        buttonMouseOverp,
        buttonMouseOutp,
      );
      UIUtil.createButton(
        mc.s4.ha,
        numberClicked,
        prefix + 's4',
        buttonMouseOverp,
        buttonMouseOutp,
      );
      UIUtil.createButton(
        mc.s5.ha,
        numberClicked,
        prefix + 's5',
        buttonMouseOverp,
        buttonMouseOutp,
      );
      UIUtil.createButton(
        mc.s6.ha,
        numberClicked,
        prefix + 's6',
        buttonMouseOverp,
        buttonMouseOutp,
      );
      UIUtil.createButton(
        mc.s7.ha,
        numberClicked,
        prefix + 's7',
        buttonMouseOverp,
        buttonMouseOutp,
      );
      UIUtil.createButton(
        mc.s8.ha,
        numberClicked,
        prefix + 's8',
        buttonMouseOverp,
        buttonMouseOutp,
      );
      UIUtil.createButton(
        mc.s9.ha,
        numberClicked,
        prefix + 's9',
        buttonMouseOverp,
        buttonMouseOutp,
      );
    }
  }

  function submitClicked() {
    let l1: number;
    let l2: number;
    let i: number;
    enableSubmitButton(false);
    l1 = UIUtil.getCurrentFrame(leftSpinner.sel.n);
    l2 = UIUtil.getCurrentFrame(rightSpinner.sel.n);
    if (gameFlag == 5) {
      l2 = l2 - 9;
    }
    if (gameFlag == 2 || gameFlag == 4 || gameFlag == 5) {
      l1 = (l1 - 9) * 10;
    }
    if (gameFlag == 1) {
      if (l2 < l1) {
        const ltemp = l1;
        l1 = l2;
        l2 = ltemp;
      }
      let intAnswerCode = -1;
      for (i = 0; i < leftArray[intAnswer - 2]!.length; i++) {
        if (leftArray[intAnswer - 2]![i] == l1) {
          if (rightArray[intAnswer - 2]![i] == l2) {
            index2 = i;
            if (arrSelected[intAnswer - 2]![i]) {
              intAnswerCode = 2;
            } else {
              arrSelected[intAnswer - 2]![i] = true;
              intAnswerCode = 1;
            }
          }
        }
      }
      index1 = intAnswer - 2;
      blnUsedAnswer = false;
      if (intAnswerCode == -1) {
        incorrectAnswer();
      } else if (intAnswerCode == 1) {
        correctAnswer();
      } else {
        usedAnswer();
      }
    } else if (gameFlag >= 2) {
      if (l1 + l2 == intAnswer) {
        correctAnswer();
      } else {
        incorrectAnswer();
      }
    }
  }

  function activateStartButton(e: TargettedEvent<unknown>) {
    const btn = UIUtil.getEventTarget(e);
    UIUtil.setFrame(btn, 2);
    UIUtil.disable(btn);

    //UIUtil.setFrame(correction,1);
    //UIUtil.show(correction,0,null);

    ValueText.displayText(correction, '', 0);
    UIUtil.setFrame(numberPanel, 1);
    createCalcButtons(leftSpinner, leftSpinnerPrefix);
    createCalcButtons(rightSpinner, rightSpinnerPrefix);
    if (startSeconds[gameFrame.round - 1] != 0) {
      if (clockTimer.isRunning()) {
        clockTimer.stop();
      }
      clockPaused = false;
      clockTimer.start();
      clockSeconds = startSeconds[gameFrame.round - 1]!;
      ValueText.whiten(gameStage.startButton.clockDisplay);
      ValueText.displayValue(
        gameStage.startButton.clockDisplay,
        clockSeconds,
        1,
      );
    } else {
      UIUtil.hide(gameStage.startButton);
    }
    buttonsClickable = true;
    getNextEquation();
  }

  function onTick() {
    clockSeconds--;
    ValueText.displayValue(gameStage.startButton.clockDisplay, clockSeconds, 1);
    if (clockSeconds < 1) {
      clockTimer.stop();
      UIUtil.clearInterval(onTick);
      timeOut();
    }
  }

  function timeOut() {
    UIUtil.cancelAllDelays();

    enableSubmitButton(false);
    enableCalculatorButtons(false);
    enableNumberButtons(false);
    buttonsClickable = false;
    LoadUtil.playSound('timeout');
    timeOutReset();
  }

  function timeOutReset() {
    //UIUtil.tween(gameStage, "alpha", 1, 0, null, resetGame, null);
    resetGame();
    resetStartButton();
  }

  function buttonMouseOver(e: object) {
    if (buttonsClickable) {
      const btn = UIUtil.getEventTarget(e as TargettedEvent<unknown>);
      UIUtil.setFrame(btn, 2);
    }
  }

  function buttonMouseOut(e: object) {
    if (buttonsClickable) {
      const btn = UIUtil.getEventTarget(e as TargettedEvent<unknown>);
      UIUtil.setFrame(btn, 1);
    }
  }

  function buttonMouseOverp(e: object) {
    if (buttonsClickable) {
      const btn = UIUtil.getEventTarget(e as TargettedEvent<unknown>).parent;
      UIUtil.setFrame(btn, 2);
    }
  }

  function buttonMouseOutp(e: object) {
    if (buttonsClickable) {
      const btn = UIUtil.getEventTarget(e as TargettedEvent<unknown>).parent;
      UIUtil.setFrame(btn, 1);
    }
  }

  function getNextEquation() {
    blnCorrectAnswer = false;

    if (clockPaused) {
      clockPaused = false;
      clockTimer.start();
    }

    if (!blnRandom) {
      if (seqindex2 >= leftArray[seqindex1]!.length) {
        seqindex2 = 0;
        seqindex1++;
      }
      intAnswer =
        leftArray[seqindex1]![seqindex2]! + rightArray[seqindex1]![seqindex2]!;
      if (gameFlag == 1) {
        ValueText.displayText(correction, intAnswer, 0);
        enableCalculatorButtons(true);
      }
      seqindex2++;
    } else {
      let i1;
      let i2;
      let minN;
      let maxN;
      let minO;
      let maxO;
      if (gameFlag == 2 || gameFlag == 4 || gameFlag == 5) {
        if (gameFlag == 2) {
          minN = 1;
        } else {
          minN = 2;
        }
        if (gameFlag == 5) {
          maxN = 8;
        } else {
          maxN = 9;
        }
        minO = 1;
        maxO = 9;
        if (gameFlag == 5) {
          minO = 10;
          maxO = 18;
        }
        i1 = Chance.randomInt(minN, maxN) * 10;
        i2 = Chance.randomInt(minO, maxO);
        while (intAnswer == i1 + i2) {
          i1 = Chance.randomInt(minN, maxN) * 10;
          i2 = Chance.randomInt(minO, maxO);
        }
        intAnswer = i1 + i2;
        ValueText.displayText(correction, intAnswer, 0);
        enableCalculatorButtons(true);
      } else if (gameFlag == 3) {
        i2 = Chance.randomInt(1, 9);
        while (gameArrayChosen[i2 - 1]) {
          i2 = Chance.randomInt(1, 9);
        }
        gameArrayChosen[i2 - 1] = true;
        intAnswer = 10 + i2;
        ValueText.displayText(correction, intAnswer, 0);
        enableCalculatorButtons(true);
      } else {
        i1 = Math.floor(Math.random() * leftArray.length);
        i2 = Math.floor(Math.random() * leftArray[i1]!.length);
        while (arrSelected[i1]![i2]) {
          i1 = Math.floor(Math.random() * leftArray.length);
          i2 = Math.floor(Math.random() * leftArray[i1]!.length);
        }
        if (gameFlag == 0) {
          arrSelected[i1]![i2] = true;
        }
        intAnswer = leftArray[i1]![i2]! + rightArray[i1]![i2]!;
        index1 = i1;
        index2 = i2;
        if (gameFlag == 1) {
          ValueText.displayText(correction, intAnswer, 0);
          enableCalculatorButtons(true);
        } else {
          UIUtil.setFrame(leftSpinner, 2);
          UIUtil.setFrame(leftSpinner.sel.n, leftArray[i1]![i2]!);
          UIUtil.setFrame(rightSpinner, 2);
          UIUtil.setFrame(rightSpinner.sel.n, rightArray[i1]![i2]!);
        }
      }
    }
    enableNumberButtons(true);
  }

  function usedAnswer() {
    blnUsedAnswer = true;
    blnCorrectAnswer = false;
    intBlinks = 0;
    blinkMarker();
  }

  function correctAnswer() {
    if (startSeconds[gameFrame.round - 1] != 0) {
      if (clockTimer.isRunning()) {
        clockTimer.stop();
        clockPaused = true;
      }
    }
    blnCorrectAnswer = true;
    if (gameFlag < 2) {
      UIUtil.setFrame(numberPanel, 1);
    }
    if (gameFlag != 3 && gameFlag != 0) {
      UIUtil.hide(leftSpinner);
      UIUtil.setFrame(leftSpinner, 1);
      enableMyButtons(leftSpinner, true);
    }
    if (gameFlag != 0) {
      UIUtil.hide(rightSpinner);
      UIUtil.setFrame(rightSpinner, 1);
      enableMyButtons(rightSpinner, true);
    }
    ValueText.displayText(correction, '', 0);
    intBlinks = 0;
    blinkMarker();
    LoadUtil.playSound('correct');
  }

  function incorrectAnswer() {
    blnCorrectAnswer = false;
    intBlinks = 0;
    ValueText.displayText(correction, intAnswer, 0);

    //BOB
    if (gameFlag == 1) {
      // && gameFrame.round >= 3
      checkForEnd();
    } else {
      blinkMarker();
    }
    LoadUtil.playSound('incorrect');
  }

  function blinkMarker() {
    let intFrame = 0;
    if (blnCorrectAnswer) {
      intFrame = 2;
    } else {
      if (blnUsedAnswer) {
        intFrame = 4;
      } else {
        intFrame = 3;
      }

      ValueText.displayText(correction, '', 0);
      if (gameFlag == 1 && !blnUsedAnswer) {
        UIUtil.setFrame(numberPanel, 1);
      }
    }
    UIUtil.setFrame(markerArray[index1]![index2], intFrame);

    if (gameFlag == 1 && (blnCorrectAnswer || blnUsedAnswer)) {
      ValueText.displayText(
        markerArray[index1]![index2]!.txtExpression,
        leftArray[index1]![index2]! + ' + ' + rightArray[index1]![index2]!,
        1,
      );
    } else {
      ValueText.displayText(markerArray[index1]![index2]!.txtExpression, '');
    }

    UIUtil.delay(unblinkMarker, 75, undefined, null);
  }

  function unblinkMarker() {
    if (intBlinks < blinkLimit) {
      UIUtil.setFrame(markerArray[index1]![index2], 1);

      if (!blnCorrectAnswer) {
        if (intBlinks < blinkLimit - 1) {
          ValueText.displayText(correction, intAnswer, 0);
        }
        if (gameFlag == 1 && !blnUsedAnswer) {
          UIUtil.setFrame(numberPanel, intAnswer + 9);
        } else if (gameFlag >= 2 && UIUtil.getCurrentFrame(numberPanel) > 20) {
          UIUtil.setFrame(numberPanel, UIUtil.getCurrentFrame(numberPanel) - 1);
        } else if (gameFlag >= 2) {
          UIUtil.setFrame(numberPanel, 1);
        }
      }
      intBlinks++;
      UIUtil.delay(blinkMarker, 75, undefined, null);
    } else {
      if (gameFlag == 1) {
        UIUtil.setFrame(markerArray[index1]![index2], 2);
      }

      checkForEnd();
    }
  }

  function checkForEnd() {
    UIUtil.cancelAllDelays();

    if (blnCorrectAnswer) {
      if (
        (gameFlag == 0 && intAnswered < 24) ||
        (gameFlag == 1 && intAnswered < 25) ||
        (gameFlag >= 2 && intAnswered < 8)
      ) {
        intAnswered++;
        if (gameFlag >= 2) {
          UIUtil.setFrame(numberPanel, intAnswered + 19);
        }
        getNextEquation();
      } else {
        intAnswered++;
        if (gameFlag >= 2) {
          UIUtil.setFrame(numberPanel, intAnswered + 19);
        }

        LoadUtil.playSound('win');
        gameOver();
      }
    } else {
      ValueText.displayText(correction, intAnswer, 0);
      if (blnUsedAnswer && !(gameFlag == 1)) {
        enableCalculatorButtons(true);
        UIUtil.setFrame(markerArray[index1]![index2], 2);
      } else {
        if (gameFlag == 1) {
          enableSubmitButton(true);
          enableCalculatorButtons(true);
          enableNumberButtons(true);
        } else {
          gameOver();
        }
      }
    }
  }

  function gameOver() {
    if (clockTimer.isRunning()) {
      clockTimer.stop();
    }
    enableSubmitButton(false);
    enableCalculatorButtons(false);
    enableNumberButtons(false);
    buttonsClickable = false;
    if (blnCorrectAnswer) {
      if (gameFlag < 2) {
        slideBar(true);
      }
      gameFrame.score = gameFrame.scoreMax;
      gameFrame.endGame();
    } else {
      resetGame();
    }
  }

  function slideBar(init: boolean) {
    if (init) {
      slideFrame = 0;
    } else {
      slideFrame++;
    }

    UIUtil.setFrame(numberPanel, slideFrame + 1);
    if (slideFrame < 9) {
      UIUtil.delay(slideBar, 75, [false], null);
    }
  }

  function resetGame() {
    UIUtil.setFrame(numberPanel, 1);

    ValueText.displayText(correction, '', 0);
    arrSelected = [
      [false],
      [false],
      [false, false],
      [false, false],
      [false, false, false],
      [false, false, false],
      [false, false, false, false],
      [false, false, false, false],
      [false, false, false, false, false],
    ];
    index1 = 0;
    index2 = 0;
    intAnswered = 0;

    resetMarkers();

    blnUsedAnswer = false;

    if (gameFlag == 1) {
      intAnswered = 1;
    }

    seqindex1 = 0;
    seqindex2 = 0;

    gameArrayChosen = [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ];

    resetStartButton();
  }

  function resetMarkers() {
    for (let i = 0; i < markerArray.length; i++) {
      for (let j = 0; j < markerArray[i]!.length; j++) {
        UIUtil.setFrame(markerArray[i]![j], 1);
        ValueText.displayText(markerArray[i]![j]!.txtExpression, '');
      }
    }
  }

  function enableNumberButtons(blnEnable: boolean) {
    for (let i = 0; i < buttonArray.length; i++) {
      if (blnEnable) {
        UIUtil.enable(buttonArray[i]!);
      } else {
        UIUtil.disable(buttonArray[i]!);
      }
    }
  }

  function enableSubmitButton(blnEnable: boolean) {
    if (blnEnable) {
      UIUtil.enable(submitButton);
    } else {
      UIUtil.disable(submitButton);
    }
  }

  function resetStartButton() {
    UIUtil.show(gameStage.startButton);
    UIUtil.setFrame(gameStage.startButton, 1);
    UIUtil.enable(gameStage.startButton);
  }

  function enableCalculatorButtons(blnEnable: boolean) {
    if (blnEnable) {
      enableMyButtons(leftSpinner, true);
      enableMyButtons(rightSpinner, true);
    } else {
      if (gameFlag != 3 && gameFlag != 0) {
        UIUtil.setFrame(leftSpinner, 1);
      }
      if (gameFlag != 0) {
        UIUtil.setFrame(rightSpinner, 1);
      }
    }
  }

  function enableMyButtons(mc: VifSpinner, blnEnable: boolean) {
    //TestUtil.log("in enable");
    if (UIUtil.getCurrentFrame(mc) == 1) {
      if (blnEnable) {
        buttonsClickable = true;
        UIUtil.setFrame(mc.s1, 1);
        UIUtil.setFrame(mc.s2, 1);
        UIUtil.setFrame(mc.s3, 1);
        UIUtil.setFrame(mc.s4, 1);
        UIUtil.setFrame(mc.s5, 1);
        UIUtil.setFrame(mc.s6, 1);
        UIUtil.setFrame(mc.s7, 1);
        UIUtil.setFrame(mc.s8, 1);
        UIUtil.setFrame(mc.s9, 1);
        UIUtil.enable(mc.s1.ha);
        UIUtil.enable(mc.s2.ha);
        UIUtil.enable(mc.s3.ha);
        UIUtil.enable(mc.s4.ha);
        UIUtil.enable(mc.s5.ha);
        UIUtil.enable(mc.s6.ha);
        UIUtil.enable(mc.s7.ha);
        UIUtil.enable(mc.s8.ha);
        UIUtil.enable(mc.s1.ha);
        UIUtil.show(mc);
      } else {
        buttonsClickable = false;
        UIUtil.disable(mc.s1.ha);
        UIUtil.disable(mc.s2.ha);
        UIUtil.disable(mc.s3.ha);
        UIUtil.disable(mc.s4.ha);
        UIUtil.disable(mc.s5.ha);
        UIUtil.disable(mc.s6.ha);
        UIUtil.disable(mc.s7.ha);
        UIUtil.disable(mc.s8.ha);
        UIUtil.disable(mc.s9.ha);
      }
    } else {
      if (blnEnable) {
        UIUtil.enable(mc.sel.ha);
      } else {
        UIUtil.disable(mc.sel.ha);
      }
    }
  }
}
